export default "__VITE_ASSET__D7vPMTW0__"